import { hasRight } from "./authorizationState";

export function hasConfiguredAccessRight(right?: string | null, siteId?: number | null) {
  if (right == null || right.trim() === "") {
    return true;
  }
  return hasRight(right, siteId);
}
